let classnames: any = {};
try {
  classnames = require('classnames');
} catch (err) {}

export default classnames;
